export default {"src":"/komodo/_next/static/media/gleec-android-qr.dc100fd4.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};